// 🚨 AUTO-GENERADO desde ProviderNoteFormDataType.ts - No editar manualmente

export const ProviderNoteFormDataKeys = [
  "id",
  "sequence",
  "document_key",
  "numero",
  "tipo",
  "fecha",
  "subtotal",
  "impuestos",
  "descuento",
  "total",
  "exchange_rate",
  "providerInvoiceId",
  "providerInvoice",
  "currencyId",
  "currency"
] as const;
